import { render } from "./usergrouptestmethodselector.vue?vue&type=template&id=8d54c238&scoped=true"
import script from "./usergrouptestmethodselector.vue?vue&type=script&lang=js"
export * from "./usergrouptestmethodselector.vue?vue&type=script&lang=js"

import "./usergrouptestmethodselector.vue?vue&type=style&index=0&id=8d54c238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d54c238"]])

export default __exports__